import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { inOutAnimation } from '../../../common/animations';
import { CalculatorResultWrapper } from '../../../common/models/analysis/calculator-result-wrapper';
import { UserRole } from '../../../common/models/user/user-role.enum';
import { PageTitleService } from '../../../services/page-title.service';
import { PaymentStatus } from '../../../common/models/payment/payment-status';
import { PriceType } from '../../../common/models/price/price';
import { PaymentType } from '../../../common/models/payment/payment-type';

@Component({
  selector: 'psc-advanced-calculator',
  templateUrl: './advanced-calculator.component.html',
  animations: [
    inOutAnimation({}),
  ],
})
export class AdvancedCalculatorComponent {
  @Input() source: string | null = null;
  calculationResultWrapper: CalculatorResultWrapper | null;
  @ViewChild('calculatorTop') calculatorTopElement: ElementRef;
  plantNeedsPayment: boolean;
  protected readonly UserRole: typeof UserRole = UserRole;

  constructor(
    private pageTitleService: PageTitleService,
  ) {
    /**
     * t(title.user.advanced-calculator)
     */
    this.pageTitleService.setTitle('title.user.advanced-calculator');
  }
  onCalculationEnded(resultWrapper: CalculatorResultWrapper) {
    if (resultWrapper.result.analysisId && resultWrapper.result.userId && !resultWrapper.result.area) {
      this.plantNeedsPayment = true;
    }
    this.calculationResultWrapper = resultWrapper;
    this.scrollToTop();
  }

  recalculate(wrapperValue: CalculatorResultWrapper) {
    this.calculationResultWrapper = wrapperValue;
    this.scrollToTop();
  }

  scrollToTop() {
    setTimeout(() => {
      this.calculatorTopElement.nativeElement.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  }

  protected readonly PaymentStatus = PaymentStatus;
  protected readonly PriceType = PriceType;
  protected readonly PaymentType = PaymentType;

  startFromBeginning() {
    this.calculationResultWrapper = null;
    this.scrollToTop();
  }
}
